import { useState } from 'react';
import { Modal, ModalProps } from '@anytag/shared-atoms';
import { PostModalContext } from './post-modal-context';

export type ControlledModalProps = ModalProps;

export const ControlledModal = ({ size = 'lg', onClose, ...restProps }: ControlledModalProps) => {
  const [modalSize, setModalSize] = useState<ModalProps['size'] | null>(size); // set null to use default size

  return (
    <PostModalContext value={{ selectedPost: null, setModalSize, closeModal: onClose }}>
      <Modal size={modalSize || size} onClose={onClose} {...restProps} />
    </PostModalContext>
  );
};
